module.exports = __webpack_public_path__ + "static/media/0a421c23-dd66-4b3a-b37d-beb9356fa1db.791d1d56.JPG";